import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  Renderer2,
} from '@angular/core';
import { BaseComponent } from '@macs-frontend/core';
import { PermissionsStore } from '@macs-frontend/features/company-management/manage/stores/permissions.store';
import { PermissionsTableItem } from '../../models/permissions-table-item';

@Component({
  selector: 'md-permissions-table',
  templateUrl: 'permissions-table.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PermissionsTableComponent extends BaseComponent {
  // @ts-expect-error
  @Input() tab: string;
  // @ts-expect-error
  @Input() permissions: string[];

  // allPermissions: Permission[] = permissionsCollection;
  allPermissions: PermissionsTableItem[] = [];

  toggleClass(event: any, targetClass: string) {
    this.togglePermissions(event.currentTarget, targetClass);
  }

  togglePermissions(target: any, targetClass: string, hide?: boolean) {
    const childrenClass = `${target.getAttribute('module-name')}_child`;
    const hasClass = target.classList.contains(targetClass);
    if (hasClass) {
      Array.from(document.getElementsByClassName(childrenClass))
        .filter(node => node.getAttribute('tab') === this.tab)
        .map(node => {
          node.setAttribute('style', 'display:none;');
          if (node.getAttribute('module-name')) {
            this.togglePermissions(node, 'active', true);
          }
        });
      this.renderer.removeClass(target, targetClass);
    } else if (!hide) {
      Array.from(document.getElementsByClassName(childrenClass))
        .filter(node => node.getAttribute('tab') === this.tab)
        .map(node => {
          node.setAttribute('style', 'display:table-row');
        });
      this.renderer.addClass(target, targetClass);
    }
  }

  checkPermission(permission: PermissionsTableItem): boolean {
    return this.permissions.indexOf(permission.path) !== -1 ? true : false;
  }

  getModuleAccessLevel(permission: PermissionsTableItem) {
    if (this.permissions.indexOf(permission.path) !== -1) {
      return 'all';
    }

    const subPermissionsPaths = this.allPermissions
      .filter(
        p => p.type === 'permission' && String(p.parent).startsWith(permission.path),
      )
      .map(p => p.path);

    const allowedCount = subPermissionsPaths.filter(p =>
      this.permissions.includes(p),
    ).length;

    if (allowedCount === 0) {
      return 'none';
    } else if (allowedCount === subPermissionsPaths.length) {
      return 'all';
    } else {
      return 'custom';
    }
  }

  checkAccessLevel(p: PermissionsTableItem, accesLevel: string): string {
    // eslint-disable-next-line functional/no-let
    let moduleAcessLevel = accesLevel;
    if (!this.checkPermission(p) && p.type === 'permission') {
      moduleAcessLevel = !moduleAcessLevel ? 'none' : 'custom';
    } else if (
      p.type === 'module' &&
      moduleAcessLevel === 'none' &&
      this.checkPermission(p)
    ) {
      moduleAcessLevel = 'custom';
    }

    return moduleAcessLevel || 'all';
  }

  setAccessLevel(permissions: PermissionsTableItem[]) {
    // eslint-disable-next-line functional/no-let
    let accessLevel: string;
    permissions.map(p => {
      accessLevel = this.checkAccessLevel(p, accessLevel);
      const nestedP: PermissionsTableItem[] = this.allPermissions.filter(
        permission => permission.parent === p.path,
      );
      nestedP.map(permission => {
        accessLevel = this.checkAccessLevel(permission, accessLevel);
        const nestedPermission: PermissionsTableItem[] = this.allPermissions.filter(
          perm => perm.parent === permission.path,
        );
        nestedPermission.map(
          perm => (accessLevel = this.checkAccessLevel(perm, accessLevel)),
        );
      });
    });
    // @ts-expect-error
    return accessLevel || 'none';
  }

  constructor(
    private renderer: Renderer2,
    readonly permissionsStore: PermissionsStore,
    readonly cdr: ChangeDetectorRef,
  ) {
    super();

    this.allPermissions = this.permissionsStore.permissions;
    this.reaction(
      () => this.permissionsStore.permissions,
      allPermissions => {
        this.allPermissions = allPermissions;
        this.cdr.markForCheck();
      },
    );
  }
}
